const s = {
  "radius-0": "0",
  "radius-0,5": "0,5",
  "radius-1": "1",
  "radius-1,5": "1,5",
  "radius-2": "2",
  "radius-2,5": "2,5",
  "radius-3": "3",
  "radius-4": "4",
  "radius-5": "5",
  "radius-6": "6",
  "radius-8": "8",
  "radius-10": "10",
  "radius-12": "12",
  "radius-full": 9999
};
export {
  s as radiusSemanticTokens
};
